import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { theme } from '../../styles/theme';
import { getUserProfile, UserProfile, resetProfile } from '../../services/userProfileService';

const Settings: React.FC = () => {
    const history = useHistory();
    const [user, setUser] = useState<UserProfile | null>(null);
    const [notifications, setNotifications] = useState(true);
    const [soundEnabled, setSoundEnabled] = useState(true);

    useEffect(() => {
        const profile = getUserProfile();
        setUser(profile);
    }, []);

    const handleResetProfile = () => {
        if (window.confirm('Are you sure? This will reset all your progress!')) {
            resetProfile();
            history.push('/');
            window.location.reload();
        }
    };

    if (!user) {
        return <div style={{ textAlign: 'center', padding: '40px 20px' }}>Loading settings...</div>;
    }

    return (
        <div style={{
            padding: '20px',
            maxWidth: '600px',
            margin: '0 auto',
            paddingBottom: '100px',
        }}>
            <button
                onClick={() => history.goBack()}
                style={{
                    marginBottom: '20px',
                    padding: '10px 16px',
                    background: theme.colors.bgSecondary,
                    border: `1px solid ${theme.colors.cardBorder}`,
                    borderRadius: '8px',
                    cursor: 'pointer',
                    fontSize: '14px',
                    color: theme.colors.textPrimary,
                    fontWeight: 600,
                }}
            >
                ← Back
            </button>

            <h1 style={{
                fontSize: '28px',
                fontWeight: 700,
                color: theme.colors.textPrimary,
                marginBottom: '32px',
            }}>
                ⚙️ Settings
            </h1>

            {/* Account Section */}
            <div style={{
                marginBottom: '32px',
            }}>
                <h2 style={{
                    fontSize: '12px',
                    fontWeight: 600,
                    color: theme.colors.textMuted,
                    marginBottom: '16px',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                }}>
                    Account
                </h2>

                <div style={{
                    padding: '16px',
                    backgroundColor: theme.colors.cardBg,
                    borderRadius: '12px',
                    marginBottom: '12px',
                }}>
                    <div style={{ marginBottom: '8px', color: theme.colors.textSecondary, fontSize: '12px' }}>
                        Player Name
                    </div>
                    <div style={{
                        fontSize: '18px',
                        fontWeight: 600,
                        color: theme.colors.textPrimary,
                    }}>
                        {user.name}
                    </div>
                </div>

                <div style={{
                    padding: '16px',
                    backgroundColor: theme.colors.cardBg,
                    borderRadius: '12px',
                    marginBottom: '12px',
                }}>
                    <div style={{ marginBottom: '8px', color: theme.colors.textSecondary, fontSize: '12px' }}>
                        Member Since
                    </div>
                    <div style={{
                        fontSize: '16px',
                        fontWeight: 600,
                        color: theme.colors.textPrimary,
                    }}>
                        {new Date(user.joinDate).toLocaleDateString()}
                    </div>
                </div>

                <div style={{
                    padding: '16px',
                    backgroundColor: theme.colors.cardBg,
                    borderRadius: '12px',
                }}>
                    <div style={{ marginBottom: '8px', color: theme.colors.textSecondary, fontSize: '12px' }}>
                        User ID
                    </div>
                    <div style={{
                        fontSize: '12px',
                        fontFamily: 'monospace',
                        color: theme.colors.textSecondary,
                        wordBreak: 'break-all',
                    }}>
                        {user.id}
                    </div>
                </div>
            </div>

            {/* Preferences Section */}
            <div style={{
                marginBottom: '32px',
            }}>
                <h2 style={{
                    fontSize: '12px',
                    fontWeight: 700,
                    color: theme.colors.textPrimary,
                    marginBottom: '16px',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                }}>
                    Preferences
                </h2>

                <div style={{
                    padding: '16px',
                    backgroundColor: theme.colors.cardBg,
                    borderRadius: '12px',
                    marginBottom: '12px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}>
                    <div>
                        <div style={{ color: theme.colors.textPrimary, fontWeight: 500 }}>🔔 Notifications</div>
                        <div style={{ fontSize: '12px', color: theme.colors.textSecondary }}>
                            Get notified about daily challenges
                        </div>
                    </div>
                    <input
                        type="checkbox"
                        checked={notifications}
                        onChange={(e) => setNotifications(e.target.checked)}
                        style={{ width: '20px', height: '20px', cursor: 'pointer' }}
                    />
                </div>

                <div style={{
                    padding: '16px',
                    backgroundColor: theme.colors.cardBg,
                    borderRadius: '12px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}>
                    <div>
                        <div style={{ color: theme.colors.textPrimary, fontWeight: 500 }}>🔊 Sound Effects</div>
                        <div style={{ fontSize: '12px', color: theme.colors.textSecondary }}>
                            Play sounds during gameplay
                        </div>
                    </div>
                    <input
                        type="checkbox"
                        checked={soundEnabled}
                        onChange={(e) => setSoundEnabled(e.target.checked)}
                        style={{ width: '20px', height: '20px', cursor: 'pointer' }}
                    />
                </div>
            </div>

            {/* Danger Zone */}
            <div style={{
                marginBottom: '32px',
            }}>
                <h2 style={{
                    fontSize: '12px',
                    fontWeight: 700,
                    color: theme.colors.textPrimary,
                    marginBottom: '16px',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                }}>
                    Danger Zone
                </h2>

                <button
                    onClick={handleResetProfile}
                    style={{
                        width: '100%',
                        padding: '16px',
                        background: '#FF6B6B',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '12px',
                        fontSize: '14px',
                        fontWeight: 600,
                        cursor: 'pointer',
                        transition: 'background 0.2s ease',
                    }}
                    onMouseOver={(e) => e.currentTarget.style.background = '#FF5252'}
                    onMouseOut={(e) => e.currentTarget.style.background = '#FF6B6B'}
                >
                    🗑️ Reset All Progress
                </button>

                <div style={{
                    marginTop: '12px',
                    padding: '12px',
                    background: 'rgba(255, 107, 107, 0.1)',
                    borderRadius: '8px',
                    fontSize: '12px',
                    color: '#FF6B6B',
                    textAlign: 'center',
                }}>
                    This action cannot be undone. Your profile, achievements, and scores will be permanently deleted.
                </div>
            </div>

            {/* About */}
            <div style={{
                padding: '16px',
                backgroundColor: theme.colors.cardBg,
                borderRadius: '12px',
                textAlign: 'center',
            }}>
                <div style={{
                    fontSize: '12px',
                    color: theme.colors.textSecondary,
                    marginBottom: '8px',
                }}>
                    Puzzzled v1.0.0
                </div>
                <div style={{
                    fontSize: '12px',
                    color: theme.colors.textSecondary,
                }}>
                    © 2024 Puzzzled. All rights reserved.
                </div>
            </div>
        </div>
    );
};

export default Settings;
